import React, { Fragment } from "react";
import styled from "styled-components";
import { AttachFile } from "@material-ui/icons";

import SecondaryButton from "./SecondaryButton";

const AttachmentsButton = ({ onClick, ...other }) => (
  <SecondaryButton onClick={onClick} {...other}>
    <AttachFile />
    <div>ATTACHMENTS</div>
  </SecondaryButton>
);
export default AttachmentsButton;
